import React from 'react';
import dompurify from 'dompurify';
import { ErrorBanner } from '../common/ErrorBanner';

export const VoteInfo = ({ isInfoPageEnabled, infoPageContent }) => {
    const sanitizer = dompurify.sanitize;

    return (
        <div className="flex items-start">
            {!isInfoPageEnabled &&
                <ErrorBanner>This ballot does not have an information page</ErrorBanner>
            }
            {isInfoPageEnabled &&
                <span dangerouslySetInnerHTML={{ __html: sanitizer(infoPageContent) }} />
            }
        </div>
    );
}